export const SortEnum = {
  ItemCode: 0,
  ItemDescription: 1,
};

export const StatusEnum = {
  All: '',
  Open: 'O',
  Closed: 'C',
};

export const StatusDescEnum = {
  Open: 'Open',
  Closed: 'Closed',
};

export const CreateEditKitchenPrepWorksheetEnum = {
  NEW: '0',
  EDIT: '1',
};

export const KitchenPrepSaveTypeEnum = {
  SaveOnly: 0,
  UpdateOnHandAndLeaveOpen: 1,
  UpdateOnHandAndClose: 2,
};

export const TabEnum = {
  Available: 'Available',
  KitchenPrepWorksheet: 'KitchenPrepWorksheet',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/KitchenPrepWorksheet.js